import { AlertTriangle } from "lucide-react";

/**
 * Aviso cuando una lectura sale vacía (6-10-2026): ningún campo con dato. Una cuenta nueva subió una foto ilegible y la pantalla solo
 * enseñaba una tabla vacía. El servidor marca `extracted_json.empty_read` (y devuelve la página si quedan reembolsos del mes); para
 * resultados antiguos, sin marca, se usa el resumen (0 campos con valor de N).
 */
export const isEmptyRead = (extractedJson) => {
  if (!extractedJson) return false;
  if (extractedJson.empty_read) return true;
  const n = Array.isArray(extractedJson.fields) ? extractedJson.fields.length : 0;
  return n > 0 && extractedJson.summary?.fields_with_values === 0;
};

export default function EmptyReadNotice({ extractedJson, t, className = "mb-4" }) {
  if (!isEmptyRead(extractedJson)) return null;
  const refunded = Boolean(extractedJson.empty_read?.refunded);
  return (
    <div role="status" data-testid="empty-read-notice" className={`${className} flex gap-3 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900`}>
      <AlertTriangle size={18} className="mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold">{t("emptyRead.title")}</p>
        <p className="mt-1">{t("emptyRead.body")}</p>
        {refunded && <p className="mt-1 font-medium">{t("emptyRead.refunded")}</p>}
      </div>
    </div>
  );
}
